import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import AutoTrain from "./autotrain.component";
import AutoStation from "./autostation.component";
import DatePicker from "../datapicker/datapicker.component";
import { setBoardingDate, setPnr, setPnrDetailStart } from '../../redux/cart/cart.action';
import { selectBoardingDate, selectPageName, selectPnr } from '../../redux/cart/cart.selector'

import image from "../../assets/icon-train-details.svg";
import './journey-details.style.css';

class journeyDetails extends React.Component {

    ydayDate = () => {
        let today = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        if (dd < 10) {
            dd = "0" + dd;
        }
        if (mm < 10) {
            mm = "0" + mm;
        }
        today = dd + "-" + mm + "-" + yyyy;
        this.props.setDate(today);
    };

    trowdate = () => {

        let today = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        if (dd < 10) {
            dd = "0" + dd;
        }
        if (mm < 10) {
            mm = "0" + mm;
        }
        today = dd + "-" + mm + "-" + yyyy;
        this.props.setDate(today);

    };
    handleChange = (event) => {
        this.props.setPnr(event.target.value);
        document.getElementById('pnr_error').style.display = "none";
        document.getElementById('station_name_error').style.display = "none";
        document.getElementById('train_name_error').style.display = "none";
    };

    render() {
        const {pnr,page,getPnrdetails} = this.props;
        return (
            <div id="journeydetail" className={ `${page === 'Station Details' ? 'active' : ''}`}>
                <div className="body">
                    <div className="container">
                        <div className="heading">
                            <img alt="logo" src={image} />
                            <h3 className="title">Journey Details</h3>
                        </div>

                        <div className={`pnrArea ${(pnr === ''?'empty':'')}`}>
                            <label >
                                Your PNR number
							</label>
                            <input
                                className=""
                                type="text"
                                id="pnr"
                                name="Pnr"
                                value={pnr}
                                
                                onChange={e=>{this.handleChange(e)}}
                            ></input>

                            <br /><span id="pnr_error" className="errorbox" style={{ display: "none" }}>Enter PNR number</span>
                        </div>
                        

                        <div className="orTab">
                            <div className="orBox1"></div>
                            <h5 className="or">OR</h5>
                            <div className="orBox2"></div>
                        </div>

                        <div className="textArea">
                            <AutoTrain />
                            <AutoStation />
                        </div>


                        <div className="textArea3"
                            style={{ marginTop: "10px", marginBottom: "30px" }}>

                            <DatePicker />
                            <div className="dateBox">
                                <h4 onClick={() => this.ydayDate()} className="yesterday"> YESTERDAY </h4>
                                <h4 onClick={() => this.trowdate()} className="tomorrow"> TOMORROW </h4>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

const mapStateToProps = createStructuredSelector({
    boardingDate: selectBoardingDate,
    pnr: selectPnr,
    page: selectPageName,
})

const mapDispatchToProps = dispatch => ({
    setDate: date => dispatch(setBoardingDate(date)),
    setPnr: pnr => dispatch(setPnr(pnr)),
    getPnrdetails: () => dispatch(setPnrDetailStart()),
})

export default connect(mapStateToProps, mapDispatchToProps)(journeyDetails);